
// import React, { useState, useEffect } from 'react';
// import { Container, Typography, Button, Grid } from '@mui/material';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';


// const Practice = () => {
//   const [highlightedWords, setHighlightedWords] = useState(new Set());
//   const [gptResponse, setGptResponse] = useState('');
//   const [userSpeech, setUserSpeech] = useState('');
//   const [wordsToPractice, setWordsToPractice] = useState([]);
//   const [rolePlayScenario, setRolePlayScenario] = useState('');
//   const navigate = useNavigate();


//   useEffect(() => {
//     const storedWords = JSON.parse(localStorage.getItem('learnedWords')) || [];
//     setWordsToPractice(storedWords.slice(-5)); // Use the last 5 learned words
//     fetchRolePlayScenario(storedWords.slice(-5));
//   }, []);

//   useEffect(() => {
//     if (userSpeech) {
//       handleUserSpeech(userSpeech);
//     }
//   }, [userSpeech]);

//   const fetchRolePlayScenario = async (words) => {
//     // The user has learned the words: ${words.join(', ')}
//     const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
//     const url = 'https://api.openai.com/v1/chat/completions';

//     const prompt = `You are going to create a simple role-play scenario for a user learning English. Suggest a simple and short role-play scenario for the user. Provide clear instructions in Arabic for the user, explaining their role in the scenario and who they are interacting with. do not exceed 50 words`;

//     try {
//       const response = await axios.post(
//         url,
//         {
//           model: 'gpt-3.5-turbo',
//           messages: [
//             { role: 'system', content: 'You are a language assistant.' },
//             {
//               role: 'user',
//               content: prompt,
//             },
//           ],
//           max_tokens: 150,
//           n: 1,
//           stop: null,
//           temperature: 0.7,
//         },
//         {
//           headers: {
//             'Authorization': `Bearer ${apiKey}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.data && response.data.choices && response.data.choices[0] && response.data.choices[0].message) {
//         setRolePlayScenario(response.data.choices[0].message.content.trim());
//         const res = await fetchGptResponseFirstTime(rolePlayScenario);
//         console.log(res);
        
//         handleTTS(res);
        

        

//       } else {
//         console.error('Unexpected API response structure:', response.data);
//         setRolePlayScenario('Sorry, there was an issue generating the role-play scenario.');
//       }
//     } catch (error) {
//       console.error('Error fetching GPT response:', error);
//       setRolePlayScenario('Sorry, there was an issue generating the role-play scenario.');
//     }
//   };

//   const handleUserSpeech = async (speech) => {
//     console.log(speech);
    
//     const highlighted = new Set([...highlightedWords]);
//     wordsToPractice.forEach(word => {
//         console.log(word);
        
//       if (speech.toLowerCase().includes(word.toLowerCase())) {
//         highlighted.add(word);
//         console.log('ff');
        
//         setTimeout(() => {
//           highlighted.delete(word);
//           setHighlightedWords(new Set([...highlighted]));
//         }, 3000);
//       }
//     });
//     setHighlightedWords(highlighted);

//     const response = await fetchGptResponse(speech);
//     setGptResponse(response);
//     handleTTS(response);
//   };

//   const fetchGptResponse = async (text) => {
//     const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
//     const url = 'https://api.openai.com/v1/chat/completions';

//     try {
//       const response = await axios.post(
//         url,
//         {
//           model: 'gpt-3.5-turbo',
//           messages: [
//             { role: 'system', content: 'Respond in short and simple sentences or phrases.' },
//             { role: 'user', content: text },
//           ],
//           max_tokens: 50,
//           n: 1,
//           stop: null,
//           temperature: 0.7,
//         },
//         {
//           headers: {
//             'Authorization': `Bearer ${apiKey}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.data && response.data.choices && response.data.choices[0] && response.data.choices[0].message) {
//         return response.data.choices[0].message.content.trim();
//       } else {
//         console.error('Unexpected API response structure:', response.data);
//         return 'Sorry, there was an issue with the response.';
//       }
//     } catch (error) {
//       console.error('Error fetching GPT response:', error);
//       return 'Sorry, I didn\'t understand that.';
//     }
//   };

//   const fetchGptResponseFirstTime = async (text) => {
//     const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
//     const url = 'https://api.openai.com/v1/chat/completions';

//     try {
//       const response = await axios.post(
//         url,
//         {
//           model: 'gpt-3.5-turbo',
//           messages: [
//             { role: 'system', content: 'Respond in short and simple sentences or phrases.' },
//             { role: 'user', content: text },
//           ],
//           max_tokens: 50,
//           n: 1,
//           stop: null,
//           temperature: 0.7,
//         },
//         {
//           headers: {
//             'Authorization': `Bearer ${apiKey}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.data && response.data.choices && response.data.choices[0] && response.data.choices[0].message) {
//         return response.data.choices[0].message.content.trim();
//       } else {
//         console.error('Unexpected API response structure:', response.data);
//         return 'Sorry, there was an issue with the response.';
//       }
//     } catch (error) {
//       console.error('Error fetching GPT response:', error);
//       return 'Sorry, I didn\'t understand that.';
//     }
//   };


//   const handleTTS = (text) => {
//     const utterance = new SpeechSynthesisUtterance(text);
//     console.log('ff');
    
   

//     utterance.lang = 'en-US';

//   const voices = window.speechSynthesis.getVoices();

//   // Directly set the voice using the name
//   const googleVoice = voices.find(voice => voice.name === 'Google US English');
  
//   if (googleVoice) {
//     utterance.voice = googleVoice;
//   }

//   speechSynthesis.speak(utterance);

    
//   };


//   const handleDone = () => {
//     const currentPoints = JSON.parse(localStorage.getItem('points')) || 0;
//     const updatedPoints = currentPoints + 5;
//     localStorage.setItem('points', JSON.stringify(updatedPoints));
//     navigate('/');
//   };
//   const handleSpeechRecognition = () => {
//     const recognition = new window.webkitSpeechRecognition();
//     recognition.lang = 'en-US';
//     recognition.continuous = false;
//     recognition.interimResults = false;

//     recognition.onresult = (event) => {
//       const transcript = event.results[0][0].transcript.trim();
//       setUserSpeech(transcript);
//     };

//     recognition.start();
//   };

//   return (
//     <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
//       <Typography variant="h5" gutterBottom>
//         Practice Role Play
//       </Typography>
//       <Typography variant="body1" style={{ marginBottom: '20px', color: 'purple' }}>
//         {rolePlayScenario}
//       </Typography>
//       <Grid container spacing={2} style={{ marginBottom: '20px' }}>
//         {wordsToPractice.map((word, index) => (
//           <Grid item xs={4} key={index}>
//             <Button
//               fullWidth
//               variant="contained"
//               style={{
//                 backgroundColor: highlightedWords.has(word) ? 'green' : 'gray',
//                 color: 'white',
//               }}
//             >
//               {word}
//             </Button>
//           </Grid>
//         ))}
//       </Grid>
//       <Button variant="contained" color="primary" onClick={handleSpeechRecognition}>
//         ســأتــحدث
//       </Button>
//       <hr></hr>
//       <Button variant="contained" color="primary" onClick={handleDone}>
//         إنــهـاء
//       </Button>
//       <Typography variant="h6" style={{ marginTop: '20px' }}>
//         {gptResponse}
//       </Typography>
//     </Container>
//   );
// };

// export default Practice;

import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, Grid } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Practice = () => {
  const [highlightedWords, setHighlightedWords] = useState(new Set());
  const [gptResponse, setGptResponse] = useState('');
  const [userSpeech, setUserSpeech] = useState('');
  const [wordsToPractice, setWordsToPractice] = useState([]);
  const [rolePlayScenario, setRolePlayScenario] = useState('');
  const [showContent, setShowContent] = useState(false); // New state for showing content
  const navigate = useNavigate();

  useEffect(() => {
    const storedWords = JSON.parse(localStorage.getItem('learnedWords')) || [];
    setWordsToPractice(storedWords.slice(-5)); // Use the last 5 learned words
    fetchRolePlayScenario(storedWords.slice(-5));
  }, []);

  useEffect(() => {
    if (userSpeech) {
      handleUserSpeech(userSpeech);
    }
  }, [userSpeech]);

  const fetchRolePlayScenario = async (words) => {
    const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
    const url = 'https://api.openai.com/v1/chat/completions';

    const prompt = `You are going to create a simple role-play scenario for a user learning English. Suggest a simple and short role-play scenario for the user. Provide clear instructions in Arabic for the user, explaining their role in the scenario and who they are interacting with. do not exceed 50 words`;

    try {
      const response = await axios.post(
        url,
        {
          model: 'gpt-3.5-turbo',
          messages: [
            { role: 'system', content: 'You are a language assistant.' },
            {
              role: 'user',
              content: prompt,
            },
          ],
          max_tokens: 150,
          n: 1,
          stop: null,
          temperature: 0.7,
        },
        {
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.choices && response.data.choices[0] && response.data.choices[0].message) {
        setRolePlayScenario(response.data.choices[0].message.content.trim());
        const res = await fetchGptResponseFirstTime(rolePlayScenario);
        console.log(res);
        handleTTS(res);
      } else {
        console.error('Unexpected API response structure:', response.data);
        setRolePlayScenario('Sorry, there was an issue generating the role-play scenario.');
      }
    } catch (error) {
      console.error('Error fetching GPT response:', error);
      setRolePlayScenario('Sorry, there was an issue generating the role-play scenario.');
    }
  };

  const handleUserSpeech = async (speech) => {
    console.log(speech);
    
    const highlighted = new Set([...highlightedWords]);
    wordsToPractice.forEach(word => {
        console.log(word);
        
      if (speech.toLowerCase().includes(word.toLowerCase())) {
        highlighted.add(word);
        console.log('ff');
        
        setTimeout(() => {
          highlighted.delete(word);
          setHighlightedWords(new Set([...highlighted]));
        }, 3000);
      }
    });
    setHighlightedWords(highlighted);

    const response = await fetchGptResponse(speech);
    setGptResponse(response);
    handleTTS(response);
  };

  const fetchGptResponse = async (text) => {
    const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
    const url = 'https://api.openai.com/v1/chat/completions';

    try {
      const response = await axios.post(
        url,
        {
          model: 'gpt-3.5-turbo',
          messages: [
            { role: 'system', content: 'Respond in short and simple sentences or phrases.' },
            { role: 'user', content: text },
          ],
          max_tokens: 50,
          n: 1,
          stop: null,
          temperature: 0.7,
        },
        {
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.choices && response.data.choices[0] && response.data.choices[0].message) {
        return response.data.choices[0].message.content.trim();
      } else {
        console.error('Unexpected API response structure:', response.data);
        return 'Sorry, there was an issue with the response.';
      }
    } catch (error) {
      console.error('Error fetching GPT response:', error);
      return 'Sorry, I didn\'t understand that.';
    }
  };

  const fetchGptResponseFirstTime = async (text) => {
    const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
    const url = 'https://api.openai.com/v1/chat/completions';

    try {
      const response = await axios.post(
        url,
        {
          model: 'gpt-3.5-turbo',
          messages: [
            { role: 'system', content: 'Respond in short and simple sentences or phrases.' },
            { role: 'user', content: text },
          ],
          max_tokens: 50,
          n: 1,
          stop: null,
          temperature: 0.7,
        },
        {
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.choices && response.data.choices[0] && response.data.choices[0].message) {
        return response.data.choices[0].message.content.trim();
      } else {
        console.error('Unexpected API response structure:', response.data);
        return 'Sorry, there was an issue with the response.';
      }
    } catch (error) {
      console.error('Error fetching GPT response:', error);
      return 'Sorry, I didn\'t understand that.';
    }
  };


  const handleTTS = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    console.log('ff');
    
   

    utterance.lang = 'en-US';

  const voices = window.speechSynthesis.getVoices();

  // Directly set the voice using the name
  const googleVoice = voices.find(voice => voice.name === 'Google US English');
  
  if (googleVoice) {
    utterance.voice = googleVoice;
  }

  speechSynthesis.speak(utterance);

    
  };


  const handleDone = () => {
    const currentPoints = JSON.parse(localStorage.getItem('points')) || 0;
    const updatedPoints = currentPoints + 5;
    localStorage.setItem('points', JSON.stringify(updatedPoints));
    navigate('/');
  };

  const handleSpeechRecognition = () => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript.trim();
      setUserSpeech(transcript);
    };

    recognition.start();
  };

  const handleStart = () => {
    setShowContent(true);
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      {!showContent ? (
        <Button variant="contained" color="primary" onClick={handleStart}>
          ابــدأ
        </Button>
      ) : (
        <>
          <Typography variant="h5" gutterBottom>
            Practice Role Play
          </Typography>
          <Typography variant="body1" style={{ marginBottom: '20px', color: 'purple' }}>
            {rolePlayScenario}
          </Typography>
          <Grid container spacing={2} style={{ marginBottom: '20px' }}>
            {wordsToPractice.map((word, index) => (
              <Grid item xs={4} key={index}>
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: highlightedWords.has(word) ? 'green' : 'gray',
                    color: 'white',
                  }}
                >
                  {word}
                </Button>
              </Grid>
            ))}
          </Grid>
          <Button variant="contained" color="primary" onClick={handleSpeechRecognition}>
            ســأتــحدث
          </Button>
          <hr></hr>
          <Button variant="contained" color="primary" onClick={handleDone}>
            إنــهـاء
          </Button>
          <Typography variant="h6" style={{ marginTop: '20px' }}>
            {gptResponse}
          </Typography>
        </>
      )}
    </Container>
  );
};

export default Practice;
